import { faTruck } from "@jewlr/pro-light-svg-icons/faTruck"
import { FontAwesomeIcon, Image } from "@jewlr/storybook/core"
import PropTypes from "prop-types"

import { jewlr_t } from "helpers/application"

import { FormTitle, TitleContainer } from "./components"

const Heading = ({ rmaType }) => {
  let title = ""

  switch (rmaType) {
    case "resize":
      title = "Request Resizing Form"
      break
    case "repair":
      title = "Request Repair Form"
      break
    case "return":
      title = "Request Return Form"
      break
    case "change-order":
      title = "Order Change Request Form"
      break
    case "upgrade-shipping":
      title = "Upgrade Shipping Request Form"
      break
    case "change-shipping-address":
      title = `Change Your ${jewlr_t("terms.Shipping")} Address`
      break
  }

  return (
    <TitleContainer>
      {["resize", "repair", "return", "change-order"].includes(rmaType) && (
        <Image
          alt={title}
          mr={{ _: "5px", tablet: "12px" }}
          src={require(`images/icons/orders/${rmaType}.svg`)}
          width="40px"
        />
      )}
      {rmaType === "upgrade-shipping" && (
        <FontAwesomeIcon
          fontSize="40px"
          icon={faTruck}
          mr={{ _: "5px", tablet: "12px" }}
        />
      )}
      <FormTitle>{title}</FormTitle>
    </TitleContainer>
  )
}

Heading.propTypes = {
  rmaType: PropTypes.string,
}

export default Heading
